// extracted by mini-css-extract-plugin
module.exports = {"shadow":"shadow--3WGcH"};